<template>
    <yxt-form-item :label="config.labelName" :prop="config.name">
    <yxt-select class="width-percent-100" v-model="value_" filterable size="small" :disabled="disabled">
      <yxt-option 
            v-for="item in list" 
            :key="item.id"
            :label="item.label"
            :value="item.id">
        </yxt-option>
    </yxt-select>
    </yxt-form-item>
</template>
<script>
export default {
  name: 'decoratModuleSelector',
  props: {
    value: {
      type: [Number, String],
      default: ''
    },
    config: {
      type: Object,
      default: () => ({})
    },
    disabled: {
      type: Boolean,
      default: false
    },
    form: {
      type: Object,
      default: () => ({})
    },
    ruleForm: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      list: [
        {
          label: '首页',
          id: 1
        },
        {
          label: '我的学习',
          id: 2
        },
        {
          label: '登陆页',
          id: 3
        }
      ]
    };
  },
  computed: {
    value_: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
        this.change(val);
      }
    }
  },
  methods: {
    change(val) {
      const obj = this.list.find(item => item.id === val) || {};
      const {id, label} = obj;
      this.$emit('change', {value: id, labelName: label});
    }
  }
};
</script>